module.exports = __webpack_public_path__ + "static/img/ZTPay.413f6ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ZTPay.png
// module id = YsJl
// module chunks = 3